"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Template3SliderReview = void 0;

var react_1 = __importDefault(require("react"));

require("./template-3-slider-review.scss");

var nanoid_1 = require("nanoid");

var component_library_waas_templates_template_3_slider_generic_1 = require("@tradesorg-components/component-library-waas-templates.template-3-slider-generic");

function Template3SliderReview(_a) {
  var title = _a.title,
      subTitle = _a.subTitle,
      items = _a.items,
      props = __rest(_a, ["title", "subTitle", "items"]);

  var settings = {
    dots: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    vertical: true,
    dotClass: "dotClass",
    infinite: items.length > 2,
    appendDots: function appendDots(dots) {
      return react_1.default.createElement("div", {
        style: {
          backgroundColor: "#ddd",
          borderRadius: "10px",
          padding: "10px"
        }
      }, react_1.default.createElement("ul", {
        style: {
          margin: "0px"
        }
      }, " ", dots, " "));
    },
    customPaging: function customPaging(i) {
      return react_1.default.createElement("div", {
        className: "dot-item"
      });
    }
  };

  var componentsToRender = function componentsToRender() {
    var component = items.length > 0 ? items.map(function (item, index) {
      var isReviewAvatarPresent = Object.keys(item).findIndex(function (itemKey) {
        return itemKey === "avatarUrl";
      }) >= 0;
      var reviewerInitialsFirstLetters = item.reviewBy.name.trim().split(' ').map(function (reviewerNamePart) {
        return reviewerNamePart[0];
      }).join('');
      var trimmedReviewerInitials = reviewerInitialsFirstLetters.length <= 2 ? reviewerInitialsFirstLetters : "".concat(reviewerInitialsFirstLetters[0]).concat(reviewerInitialsFirstLetters[reviewerInitialsFirstLetters.length - 1]);
      return react_1.default.createElement("div", {
        key: (0, nanoid_1.nanoid)(),
        className: "reviewItemWrapper w-full h-auto h-310px md-1:h-335 mx-auto pb-4"
      }, react_1.default.createElement("div", {
        className: "relative mx-auto reviewItem px-31px md-1:px-42px md-1:py-51px ".concat(index % 2 === 0 ? "bg-gray-50 pt-50px pb-30px" : "py-30px")
      }, react_1.default.createElement("div", {
        className: "reviewer flex "
      }, isReviewAvatarPresent ? react_1.default.createElement("div", {
        className: "avatar-wrapper relative w-11 h-11 rounded-full overflow-hidden"
      }, react_1.default.createElement("img", {
        src: item.reviewBy.avatarUrl,
        alt: "reviewer avatar",
        className: "w-full h-auto absolute top-50% left-50% -translateXY-50%"
      })) : react_1.default.createElement("div", {
        className: 'flex bg-blue-100 w-50px h-50px rounded-full items-center justify-center'
      }, react_1.default.createElement("span", {
        className: 'text- text-blue-500'
      }, trimmedReviewerInitials)), react_1.default.createElement("div", {
        className: "reviewer-info flex flex-col pl-20px my-auto"
      }, react_1.default.createElement("p", {
        className: "reviewerName font-16px"
      }, item.reviewBy.name), react_1.default.createElement("p", {
        className: "reviewerTitle font-14px"
      }, item.reviewBy.title))), react_1.default.createElement("p", {
        className: "reviewContent pt-21px font-14px md-1:font-16px"
      }, item.content.length >= 200 ? "".concat(item.content.slice(0, 197), "...") : item.content)));
    }) : react_1.default.createElement(react_1.default.Fragment, null);
    return component;
  };

  return react_1.default.createElement("div", Object.assign({
    className: "slider slider-review-wrapper"
  }, props), react_1.default.createElement(component_library_waas_templates_template_3_slider_generic_1.Template3SliderGeneric, {
    subTitle: subTitle,
    title: title,
    componentsToRender: componentsToRender(),
    customSetting: settings
  }));
}

exports.Template3SliderReview = Template3SliderReview;